/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
angular.module('public.security-manager.client.list').directive('gccsClientListPreview', () =>
  ({
    restrict: 'A',
    controller: 'ClientListPreviewController',
    controllerAs: 'clientListPreviewCtrl',
    template: require('./template.pug'),
    scope: {
      client: '=',
      editable: '<'
    }
  })
);
